import { LEAVE_CODE_VACATION_DAYS_IDS } from '../../../constants-v2/staff/leave-code';
import personFullName from '../../../filters/person/person-full-name';
import modelId from '../../../procedures/model-id';
import column from '../../abstract/column';
import vars from '../../abstract/vars';
import actions from './actions';
import api, { modelName } from './api';

export default {
  actions,
  topRightActions: {
    create: {
      label: 'Dodaj nieobecność',
      icon: 'icon-plus',
      handle: async ({ $router }) => await $router.push('/leaves/add'),
    },
  },
  api,
  modelName,
  sidebarData: {
    id: column({
      label: 'Identyfikator',
      size: 100
    }),
  },
  columns: {
    name: column({ label: 'Imię', format: item => item?.staff?.employee?.person?.name }),
    surname: column({ label: 'Nazwisko', format: item => item?.staff?.employee?.person?.surname }),
    pesel: column({ label: 'PESEL', format: item => item?.staff?.employee?.person?.pesel }),
    leavecode: column({
      label: 'Kod przerwy',
      component: 'value-status-tooltips',
      items: ({ item }) => [
        {
          label: `${ item?.leavecode?.code }`,
          tooltip: `${ item?.leavecode?.name }`,
        },
      ],
    }),
    start_date: column({ label: 'Data od' }),
    end_date: column({ label: 'Data do' }),
    number_of_days: column({
      label: 'Ilość dni',
      component: 'value-status-tooltips',
      items: ({ item }) => {
        let tooltip = 'Wartość obliczona na podstawie ilości dni kalendarzowych';
        if (item?.leavecode && LEAVE_CODE_VACATION_DAYS_IDS.includes(modelId(item?.leavecode))) {
          tooltip = 'Wartość obliczona na podstawie ilości dni roboczych';
        }

        return [
          {
            contentColor: 'grey',
            label: `${ item?.number_of_days }`,
            tooltip,
          },
        ];
      },
    }),
  },
  vars: vars({
    noItemsText: ({ $router, $route }) => {
      if ($route?.query?.filters) {
        return 'Brak wyników spełniających kryteria wyszukiwania.';
      }
      return 'Brak nieobecności.';
    },
    sidebarLabel: 'Podgląd nieobecności',
    softDelete: {
      title: 'Usunięcie nieobecności',
      text: (item) => `Czy na pewno chcesz usunąć nieobecność dla ${ personFullName(item?.staff?.employee?.person) }?`,
      successText: 'Nieobecność została usunięta',
    },
  }),
};
